---
en:
  portfolio_stats:
    aggregated_intraday_hourly_revenue: Aggregated intraday hourly revenue
    click_to_refresh: Click here to refresh
    heading: Portfolio statistics
    hourly_revenue: Hourly revenue
    hourly_revenue_warning: Hourly revenue chart disabled when there is more than 200 power plants
    monthly_revenue: Monthly Revenue
    of_budget: of budget
    portfolio_production: Portfolio production overview
    portfolio_total: Portfolio total
    power_plant_age_distribution: Power plant age distribution
    power_plants_yearly_load_hour: Power plants yearly load hour
    prod_and_runoff_vs_normal: Production and runoff vs. normal
    prod_vs_bud: Production vs. budget
    prod_vs_normal: Production vs. normal
    prod_vs_normal_ytd: Production vs. normal YTD
    production_ytd: Production YTD
    rev_and_bud: Revenue and budget
    rev_and_bud_ytd: Revenue and budget YTD
    rev_vs_bud: Revenue vs. budget
    rev_vs_bud_ytd: Revenue vs. budget YTD
    revenue_ytd: Revenue YTD
    runoff_vs_average: Runoff vs. average
    runoff_vs_normal_ytd: Production and runoff vs. normal YTD
    technical_downtime: Technical downtime overview
